import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CallResponse, CallSettingsResponse, PlaceCallInput, UpdateCallSettingsInput } from '@orion/contracts';
import { api } from '../../../lib/api-client.js';

export function useCallSettingsQuery() {
  return useQuery({ queryKey: ['calling-settings'], queryFn: () => api.get<CallSettingsResponse>('/calling/settings') });
}

export function useUpdateCallSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateCallSettingsInput) => api.patch<CallSettingsResponse>('/calling/settings', input),
    onSuccess: (data) => queryClient.setQueryData(['calling-settings'], data),
  });
}

/** Rings the rep's own saved bridge number first, then connects them to the
 * lead — see `CallsService.place` on the API side. Returns the new `Call`
 * row; `useCallQuery` below polls it for live status. */
export function usePlaceCall() {
  return useMutation({ mutationFn: (input: PlaceCallInput) => api.post<CallResponse>('/calling/calls', input) });
}

const TERMINAL_CALL_STATUSES: CallResponse['status'][] = ['completed', 'failed', 'no-answer', 'busy', 'canceled'];

export function useCallQuery(id: string | null) {
  return useQuery({
    queryKey: ['calling-call', id],
    queryFn: () => api.get<CallResponse>(`/calling/calls/${id}`),
    enabled: Boolean(id),
    refetchInterval: (query) => (query.state.data && TERMINAL_CALL_STATUSES.includes(query.state.data.status) ? false : 1500),
  });
}
